module.exports = __webpack_public_path__ + "assets/dienst3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst3.jpg
// module id = 359
// module chunks = 0